var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "group-quote-modal",
      "hide-header-close": "",
      "size": "lg",
      "centered": ""
    },
    on: {
      "show": _vm.getRepInfo
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "close-btn",
      "btn-container-quote": ""
    },
    on: {
      "click": _vm.closeGroupQuoteModal
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _c('div', {
    staticClass: "quote-modal text-center pb-1"
  }, [_c('h5', [_c('strong', [_vm._v("Send New Group Quote")])])]), !_vm.isFormVisible ? _c('div', {
    staticClass: "select-new-existing text-center pt-0"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('div', [_vm._v("Group quote for a")]), _c('div', {
    staticClass: "new-group-option ms-2",
    on: {
      "click": _vm.onNewGroupSelect
    }
  }, [_vm._v("New group")])]), _c('div', {
    staticClass: "mb-2 mt-2"
  }, [_vm._v("OR,")]), _c('multiselect', {
    attrs: {
      "name": "group",
      "placeholder": "Select Existing Groups",
      "options": _vm.existingGroups.map(function (item) {
        return {
          text: item.gname,
          value: item.gid
        };
      }),
      "custom-label": function customLabel(opt) {
        return opt.text;
      },
      "options-limit": 100,
      "internal-search": false,
      "local-search": false
    },
    on: {
      "search-change": _vm.searchHandler,
      "select": _vm.onExistingGroupSelect
    }
  })], 1)]) : _vm._e(), _vm.isFormVisible ? _c('div', {
    attrs: {
      "id": "group-quote"
    }
  }, [_c('ValidationObserver', {
    ref: "observer",
    attrs: {
      "mode": "lazy"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return handleSubmit(_vm.submitGroupQuote);
            }
          }
        }, [_c('div', {
          staticClass: "row mt-2"
        }, [_c('input-text', {
          attrs: {
            "labelName": "Group Name",
            "labelFor": "groupName",
            "inputName": "groupName",
            "formGroupClass": "border-0 col-xxl-4 col-lg-4 col-md-6 mb-3",
            "vmodel": _vm.groupName,
            "rules": {
              required: true
            },
            "readonly": _vm.isAnExistingGroup
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              _vm.groupName = $event;
            }
          }
        }), _c('input-text', {
          attrs: {
            "labelName": "Group Address",
            "labelFor": "groupAddress",
            "inputName": "groupAddress",
            "formGroupClass": "border-0 col-xxl-4 col-lg-4 col-md-6 mb-3",
            "vmodel": _vm.groupAddress,
            "rules": {
              required: true
            },
            "readonly": _vm.isAnExistingGroup
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              _vm.groupAddress = $event;
            }
          }
        }), _c('input-date-picker', {
          attrs: {
            "vmodel": _vm.requestedStartDate,
            "rules": {
              required: true
            },
            "inputName": "requstedDate",
            "label": "Requested Start Date",
            "date-format": "MM/DD/YYYY",
            "form-group-class": "col-xxl-4 col-lg-4 col-md-6 mb-3",
            "inputClass": "form-control",
            "disableDateType": "disable-upto-yesterday",
            "placeholder": "Request Start Date",
            "isDisabled": _vm.isAnExistingGroup
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              _vm.requestedStartDate = $event;
            }
          }
        }), _c('input-select', {
          attrs: {
            "labelName": "Group Industry",
            "labelFor": "groupIndustry",
            "defaultOption": "Select Industry",
            "inputName": "groupIndustry",
            "formGroupClass": "border-0 col-xxl-4 col-lg-4 col-md-6 mb-3",
            "vmodel": _vm.groupIndustry,
            "rules": {
              required: true
            },
            "options": _vm.groupIndustryList,
            "disabled": _vm.isAnExistingGroup
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              _vm.groupIndustry = $event;
            }
          }
        }), _c('input-text', {
          attrs: {
            "labelName": "Group Contact Name",
            "labelFor": "contactName",
            "inputName": "contactName",
            "formGroupClass": "border-0 col-xxl-4 col-lg-4 col-md-6 mb-3",
            "vmodel": _vm.contactName,
            "rules": {
              required: true
            },
            "readonly": _vm.isAnExistingGroup
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              _vm.contactName = $event;
            }
          }
        }), _c('input-text', {
          attrs: {
            "labelName": "Group Contact Email",
            "labelFor": "contactEmail",
            "inputName": "contactEmail",
            "formGroupClass": "border-0 col-xxl-4 col-lg-4 col-md-6 mb-3",
            "vmodel": _vm.contactEmail,
            "rules": {
              required: true,
              email: true
            },
            "readonly": _vm.isAnExistingGroup
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              _vm.contactEmail = $event;
            }
          }
        }), _c('input-text', {
          attrs: {
            "labelName": "Group Contact Phone Number",
            "labelFor": "contactNumber",
            "inputName": "contactNumber",
            "formGroupClass": "border-0 col-xxl-4 col-lg-4 col-md-6 mb-3",
            "vmodel": _vm.contactNumber,
            "rules": {
              required: true,
              clearoutPhone: true
            },
            "maxLength": 10,
            "readonly": _vm.isAnExistingGroup
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              _vm.contactNumber = $event;
            }
          }
        }), _c('input-select', {
          attrs: {
            "labelName": "Enrollment Platform",
            "labelFor": "enrollmentPlatform",
            "inputName": "enrollmentPlatform",
            "defaultOption": "Select Enrollment Platform",
            "formGroupClass": "border-0 col-xxl-4 col-lg-4 col-md-6 mb-3",
            "vmodel": _vm.enrollmentPlatform,
            "rules": {
              required: true
            },
            "options": _vm.enrollmentPlatformList,
            "disabled": _vm.isAnExistingGroup
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              _vm.enrollmentPlatform = $event;
            }
          }
        })], 1), _c('div', {
          staticClass: "row mt-2"
        }, [_c('div', {
          staticClass: "d-flex col-12 gap-3 quote-action-btns"
        }, [_c('button', {
          staticClass: "btn secondary-btn mt-0",
          attrs: {
            "type": "submit"
          },
          on: {
            "click": _vm.onBackClick
          }
        }, [_vm._v("Back")]), _c('button', {
          staticClass: "new-quote-btn mt-0",
          attrs: {
            "type": "submit"
          }
        }, [_vm._v("Submit")])])])])];
      }
    }], null, false, 4124464278)
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }